import React from 'react'

const OutIcon = ({ width = 18, height = 15 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 18 15"
  >
    <path
      fill="#b18935"
      fillRule="evenodd"
      d="M18,17H3V11.75H4.5V15.5h12V3.5H4.5V7.25H3V2H18ZM8.25,8.75v-3l4.5,3.75-4.5,3.75v-3H0V8.75Z"
      transform="translate(0 -2)"
    />
  </svg>
)
export default OutIcon
